import ModalIconAiHelp from './modal-icon-ai-help.svg';
import ModalIconBluehost from './modal-icon-bluehost.svg';
import ModalIconDefault from './modal-icon-default.svg';
import ModalIconHostGator from './modal-icon-hostgator.svg';
import ModalIconWonderblocks from './modal-icon-wonderblocks.svg';
import ModalIconWordpress from './modal-icon-wordpress.svg';

export {
  ModalIconAiHelp,
  ModalIconBluehost,
  ModalIconDefault,
  ModalIconHostGator,
  ModalIconWonderblocks,
  ModalIconWordpress,
};
